const initialState = {
  name: null,
  email: null,
  phoneNumber: null,
  brands: ["adp", "fnac", "sncf"],
  apps: ["call-bot", "web-app", "allo-brain"],
  currentApp: null,
  currentBrand: null,
  currentFlowName: null,
  currentVersion: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "change-app":
      return {
        ...state,
        currentApp: action.app,
      };
    case "change-brand":
      return {
        ...state,
        currentBrand: action.brand,
      };
    case "change-flow-name":
      return {
        ...state,
        currentFlowName: action.flowName,
      };
    case "change-version":
      return {
        ...state,
        currentVersion: action.version,
      };
    case "update-user-info":
      return {
        ...state,
        name: action.name,
        email: action.email,
        phoneNumber: action.phoneNumber,
      };
    default:
      return initialState;
  }
};

export { reducer, initialState };
